import getHelper from '../../../services/getHelper';

export default getHelper('/paths/:id', {
  students: getHelper('/students/:id'),
});
